import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FileCategoryState } from "../objects/fileCategoryState";
import { FileCategory } from "../objects/fileCategory";
import { EMPTY_FILE_CATEGORY_LIST_CRITERIA } from "../constants/fileCategoryConstants";
import { FileCategoryListCriteria } from "../objects/fileCategoryList";

const initialState: FileCategoryState = {
    file_category_list: [],
    file_category_list_count: 0,
    file_category_list_criteria: EMPTY_FILE_CATEGORY_LIST_CRITERIA,
    file_category_list_loading: false,
    file_category: null,
    file_category_delete: null,
};

const setFileCategoryListReducer = (state: FileCategoryState, action: PayloadAction<FileCategory[]>): FileCategoryState => ({
    ...state, file_category_list: action.payload
});
const setFileCategoryListCountReducer = (state: FileCategoryState, action: PayloadAction<number>): FileCategoryState => ({
    ...state, file_category_list_count: action.payload
});

const setFileCategoryListLoadingReducer = (state: FileCategoryState, action: PayloadAction<boolean>): FileCategoryState => ({
    ...state, file_category_list_loading: action.payload
});
const setFileCategoryReducer = (state: FileCategoryState, action: PayloadAction<FileCategory | null>): FileCategoryState => ({
    ...state, file_category: action.payload
});
const setFileCategoryDeleteReducer = (state: FileCategoryState, action: PayloadAction<FileCategory | null>): FileCategoryState => ({
    ...state, file_category_delete: action.payload
});
const setFileCategoryListCriteriaReducer = (state: FileCategoryState, action: PayloadAction<FileCategoryListCriteria>): FileCategoryState => ({
    ...state, file_category_list_criteria: action.payload
});
export const fileCategory = createSlice({
    name: 'file_category',
    initialState,
    reducers: {
        setFileCategoryList: setFileCategoryListReducer,
        setFileCategoryListCount: setFileCategoryListCountReducer,
        setFileCategoryListLoading: setFileCategoryListLoadingReducer,
        setFileCategory: setFileCategoryReducer,
        setFileCategoryDelete: setFileCategoryDeleteReducer,
        setFileCategoryListCriteria: setFileCategoryListCriteriaReducer
    }
});

export const {
    setFileCategoryList,
    setFileCategoryListCount,
    setFileCategoryListLoading,
    setFileCategory,
    setFileCategoryDelete,
    setFileCategoryListCriteria
} = fileCategory.actions;